import { useMediaQueryBreakpoint } from "@hooks";

import {
  HorizontalAccordionOuterWrapper,
  HorizontalAccordionInnerWrapper,
  VerticalAccordionWrapper,
} from "./styles.styled";
import { AreaDef, WorkingAreaItemContent } from "./WorkingAreaItemContent";

interface WorkingAreaItemProps {
  area: AreaDef;
  areaIndex: number;
  openedIndex: number;
  openTab: () => void;
  areasAmount: number;
}

export const WorkingAreaItem = ({
  area,
  areaIndex,
  openedIndex,
  openTab,
  areasAmount,
}: WorkingAreaItemProps) => {
  const isOpened = openedIndex === areaIndex;
  const { isDesktop } = useMediaQueryBreakpoint();

  if (isDesktop)
    return (
      <HorizontalAccordionOuterWrapper
        areaIndex={areaIndex}
        openedIndex={openedIndex}
        areasAmount={areasAmount}
      >
        <HorizontalAccordionInnerWrapper
          color={area.color}
          borderColor={area.borderColor}
        >
          <WorkingAreaItemContent
            area={area}
            areaIndex={areaIndex}
            isOpened={isOpened}
            openTab={openTab}
          />
        </HorizontalAccordionInnerWrapper>
      </HorizontalAccordionOuterWrapper>
    );

  return (
    <VerticalAccordionWrapper
      areaIndex={areaIndex}
      openedIndex={openedIndex}
      color={area.color}
      borderColor={area.borderColor}
    >
      <WorkingAreaItemContent
        area={area}
        areaIndex={areaIndex}
        isOpened={isOpened}
        openTab={openTab}
        isVerticalAccordion
      />
    </VerticalAccordionWrapper>
  );
};
